const { REACT_APP_API_URL, REACT_APP_MEDIA_FILES_BASE_URL } = process.env;

const API_URL = REACT_APP_API_URL;
export const MEDIA_FILES_BASE_URL = REACT_APP_MEDIA_FILES_BASE_URL;

export const APIS: any = {
	AUTH: {
		LOGIN: {
			url: `${API_URL}/admins/auth/login`,
			method: 'POST',
			useMock: false,
		},
		VERIFY_RESET_PASSWORD_LINK: {
			url: `${API_URL}/admins/auth/verify-reset-password-link`,
			method: 'POST',
		},
		RESET_PASSWORD_REQUEST: {
			url: `${API_URL}/admins/auth/reset-password-request`,
			method: 'POST',
			useMock: false,
		},
		RESET_PASSWORD: {
			url: `${API_URL}/admins/auth/reset-password`,
			method: 'POST',
			useMock: false,
		},
		REFRESH_TOKEN: {
			url: `${API_URL}/admins/auth/refresh-token`,
			method: 'POST',
		},
		LOGOUT: {
			url: `${API_URL}/admins/auth/logout`,
			method: 'GET',
		},
	},
	DASHBOARD: {
		GET_ALL_STATS: {
			url: `${API_URL}/end-users/stats/all`,
			method: 'GET',
		},
		GET_NEW_USERS_COUNTS_STATS: {
			url: `${API_URL}/end-users/stats/new-users-counts`, // ?fromDate=2022-11-15&toDate=2022-11-20`
			method: 'GET',
		},
		GET_ACTIVE_USERS_COUNTS_STATS: {
			url: `${API_URL}/end-users/stats/active-users-counts`, // ?fromDate=2022-11-15&toDate=2022-11-20`
			method: 'GET',
		},
		GET_REGIONS_USERS_COUNTS_STATS: {
			url: `${API_URL}/end-users/stats/regions-users-counts`,
			method: 'GET',
		},
		GET_COMPLETED_REGION_LESSONS_USERS_COUNTS_STATS: {
			url: `${API_URL}/end-users/stats/completed-region-lessons-users-count`, // ?region=0
			method: 'GET',
		},
		GET_MOST_RECENT_USERS: {
			url: `${API_URL}/end-users/stats/most-recent`,
			method: 'GET',
		},
	},
	END_USERS_MANAGEMENT: {
		GET_END_USERS: {
			url: `${API_URL}/end-users`, // ?page=,..filters args
			method: 'GET',
		},
		SEARCH_END_USERS_BY_EMAIL: {
			url: `${API_URL}/end-users/search/email`, // ?searchKey=
			method: 'GET',
		},
		SEARCH_END_USERS_BY_NAME: {
			url: `${API_URL}/end-users/search/name`, // ?searchKey=
			method: 'GET',
		},
		GET_END_USER: {
			url: `${API_URL}/end-users`, // /:id
			method: 'GET',
		},
		GET_END_USER_COMPLETED_LESSONS: {
			url: `${API_URL}/lessons-progress/:endUserId/lessons`, // /:id, ?page=, ?l
			method: 'GET',
		},
		GET_END_USER_VOCAB_LESSON_WORDS_REVIEW: {
			url: `${API_URL}/lessons-progress/:endUserId/lessons/:lessonId/vocab/words-review`, // /:userId/:lessonId
			method: 'GET',
		},
		GET_END_USER_VERB_LESSON_WORDS_REVIEW: {
			url: `${API_URL}/lessons-progress/:endUserId/lessons/:lessonId/verb/words-review`, // /:userId/:lessonId
			method: 'GET',
		},
		GET_END_USER_GRAMMAR_LESSON_WORDS_REVIEW: {
			url: `${API_URL}/lessons-progress/:endUserId/lessons/:lessonId/grammar/words-review`, // /:userId/:lessonId
			method: 'GET',
		},
		GET_END_USER_SORTING_LESSON_WORDS_REVIEW: {
			url: `${API_URL}/lessons-progress/:endUserId/lessons/:lessonId/sorting/words-review`, // /:userId/:lessonId
			method: 'GET',
		},
		GET_END_USER_SIGHT_WORDS_LESSON_WORDS_REVIEW: {
			url: `${API_URL}/lessons-progress/:endUserId/lessons/:lessonId/sight-words/words-review`, // /:userId/:lessonId
			method: 'GET',
		},
		SEND_END_USER_RESET_PASS_ACTION: {
			url: `${API_URL}/end-users/actions/reset-password`, // /:id
			method: 'POST',
		},
		LOCK_END_USER_RESET_PASS_ACTION: {
			url: `${API_URL}/end-users/actions/lock`, // /:id
			method: 'POST',
		},
		UNLOCK_END_USER_RESET_PASS_ACTION: {
			url: `${API_URL}/end-users/actions/unlock`, // /:id
			method: 'POST',
		},

		EXPORT_END_USERS_TO_CSV: {
			url: `${API_URL}/end-users/export/csv`,
			method: 'GET',
		},
	},
	ONBOARDING_QUESTION: {
		GET_QUESTION: {
			url: `${API_URL}/onboarding-questions`, // /:id
			method: 'GET',
		},
		GET_QUESTIONS: {
			url: `${API_URL}/onboarding-questions`, // ?page=number
			method: 'GET',
		},
		DELETE_QUESTION: {
			url: `${API_URL}/onboarding-questions`, // /:id
			method: 'DELETE',
		},
		ADD_QUESTION: {
			url: `${API_URL}/onboarding-questions`,
			method: 'POST',
		},
		UPDATE_QUESTION: {
			url: `${API_URL}/onboarding-questions`,
			method: 'PUT',
		},
	},
	REGIONS_CONFIGURATION: {
		GET_LESSONS: {
			url: `${API_URL}/lessons`,
			method: 'GET',
		},
		SEARCH_LESSONS_AUTO_COMPLETE: {
			url: `${API_URL}/lessons/search`,
			method: 'GET',
		},
		DELETE_LESSON: {
			url: `${API_URL}/lessons`, // /:type{vocab|verb|lexicary|sentence}/:id
			method: 'DELETE',
		},
		GET_REGION_NEW_LESSON_DEFAULT_ORDER: {
			url: `${API_URL}/lessons/new-order`, // /:region
			method: 'GET',
		},
		CREATE_VOCAB_LESSON: {
			url: `${API_URL}/lessons/vocab`,
			method: 'POST',
		},
		UPDATE_VOCAB_LESSON: {
			url: `${API_URL}/lessons/vocab`,
			method: 'PUT',
		},
		CREATE_VERB_LESSON: {
			url: `${API_URL}/lessons/verb`,
			method: 'POST',
		},
		UPDATE_VERB_LESSON: {
			url: `${API_URL}/lessons/verb`,
			method: 'PUT',
		},

		GET_VOCAB_LESSON: {
			url: `${API_URL}/lessons/vocab`, // /:id
			method: 'GET',
		},
		GET_VERB_LESSON: {
			url: `${API_URL}/lessons/verb`,
			method: 'GET',
		},

		GET_SENTENCE_LESSONS_WITH_VOCAB_WORD: {
			url: `${API_URL}/sentences/with-vocab-word`, // /:vocabWordId
			method: 'GET',
		},
		GET_SENTENCE_LESSONS_WITH_VOCAB_LESSON_WORDS: {
			url: `${API_URL}/sentences/with-vocab-lesson`, // /:vocabLessonId
			method: 'GET',
		},

		GET_SENTENCE_LESSONS_WITH_ORDER_LESS_THAN_VOCAB_LESSON_NEW_ORDER: {
			url: `${API_URL}/lessons/sentence/with-order-less-than-vocab-lesson-new-order`, // /:vocabLessonId/:newOrder
			method: 'GET',
		},

		GET_SENTENCE_LESSON: {
			url: `${API_URL}/lessons/sentence`,
			method: 'GET',
		},

		CREATE_SENTENCE_LESSON: {
			url: `${API_URL}/lessons/sentence`,
			method: 'POST',
		},

		UPDATE_SENTENCE_LESSON: {
			url: `${API_URL}/lessons/sentence`,
			method: 'PUT',
		},

		SEARCH_SENTENCE_LESSON_VOCAB_WORDS: {
			url: `${API_URL}/sentences/search/words`, //query params: ?searchKey=gIrl&sentenceLessonRegion=0&sentenceLessonOrder=4
			method: 'GET',
		},

		GET_LEXICARY_LESSON: {
			url: `${API_URL}/lessons/lexicary`,
			method: 'GET',
		},

		CREATE_LEXICARY_LESSON: {
			url: `${API_URL}/lessons/lexicary`,
			method: 'POST',
		},

		UPDATE_LEXICARY_LESSON: {
			url: `${API_URL}/lessons/lexicary`,
			method: 'PUT',
		},
		SEARCH_LESSON_ITEM_MODIFIERS: {
			url: `${API_URL}/lesson-item-modifiers/search`, // ?searchKey
			method: 'GET',
		},
		DELETE_LESSON_ITEM_MODIFIER: {
			url: `${API_URL}/lesson-item-modifiers`,
			method: 'DELETE',
		},
		CREATE_LESSON_ITEM_MODIFIER: {
			url: `${API_URL}/lesson-item-modifiers`,
			method: 'POST',
		},
		GET_LESSON_ITEM_MODIFIER: {
			url: `${API_URL}/lesson-item-modifiers`, // /:id
			method: 'GET',
		},
		UPDATE_LESSON_ITEM_MODIFIER: {
			url: `${API_URL}/lesson-item-modifiers`,
			method: 'PUT',
		},

		GET_GRAMMAR_LESSON: {
			url: `${API_URL}/lessons/grammar`,
			method: 'GET',
		},

		CREATE_GRAMMAR_LESSON: {
			url: `${API_URL}/lessons/grammar`,
			method: 'POST',
		},

		UPDATE_GRAMMAR_LESSON: {
			url: `${API_URL}/lessons/grammar`,
			method: 'PUT',
		},

		GET_SORTING_LESSON: {
			url: `${API_URL}/lessons/sorting`,
			method: 'GET',
		},

		CREATE_SORTING_LESSON: {
			url: `${API_URL}/lessons/sorting`,
			method: 'POST',
		},

		UPDATE_SORTING_LESSON: {
			url: `${API_URL}/lessons/sorting`,
			method: 'PUT',
		},

		GET_BUSY_PICTURE_LESSON: {
			url: `${API_URL}/lessons/busy-picture`,
			method: 'GET',
		},

		CREATE_BUSY_PICTURE_LESSON: {
			url: `${API_URL}/lessons/busy-picture`,
			method: 'POST',
		},

		UPDATE_BUSY_PICTURE_LESSON: {
			url: `${API_URL}/lessons/busy-picture`,
			method: 'PUT',
		},

		GET_NUMBER_COMBINATION_LESSON: {
			url: `${API_URL}/lessons/number-combination`,
			method: 'GET',
		},

		CREATE_NUMBER_COMBINATION_LESSON: {
			url: `${API_URL}/lessons/number-combination`,
			method: 'POST',
		},

		UPDATE_NUMBER_COMBINATION_LESSON: {
			url: `${API_URL}/lessons/number-combination`,
			method: 'PUT',
		},

		GET_SIGHT_WORDS_LESSON: {
			url: `${API_URL}/lessons/sight-words`,
			method: 'GET',
		},

		CREATE_SIGHT_WORDS_LESSON: {
			url: `${API_URL}/lessons/sight-words`,
			method: 'POST',
		},

		UPDATE_SIGHT_WORDS_LESSON: {
			url: `${API_URL}/lessons/sight-words`,
			method: 'PUT',
		},

		GET_TIME_LESSON: {
			url: `${API_URL}/lessons/time`,
			method: 'GET',
		},

		CREATE_TIME_LESSON: {
			url: `${API_URL}/lessons/time`,
			method: 'POST',
		},

		UPDATE_TIME_LESSON: {
			url: `${API_URL}/lessons/time`,
			method: 'PUT',
		},

		SEARCH_VOCAB_WORDS_FROM_PREVIOUS_LESSONS: {
			url: `${API_URL}/lessons/vocab/search-words-from-previous-lessons`,
			method: 'GET',
		},

		GET_CATEGORIES: {
			url: `${API_URL}/lesson-categories`,
			method: 'GET',
		},
		SEARCH_CATEGORIES: {
			url: `${API_URL}/lesson-categories/search`,
			method: 'GET',
		},
		CREATE_CATEGORY: {
			url: `${API_URL}/lesson-categories`,
			method: 'POST',
		},
		UPDATE_CATEGORY: {
			url: `${API_URL}/lesson-categories`,
			method: 'PUT',
		},
		DELETE_CATEGORY: {
			url: `${API_URL}/lesson-categories`,
			method: 'DELETE',
		},

		GET_SCENE_MATCHING_LESSON: {
			url: `${API_URL}/lessons/scene-matching`,
			method: 'GET',
		},

		CREATE_SCENE_MATCHING_LESSON: {
			url: `${API_URL}/lessons/scene-matching`,
			method: 'POST',
		},

		UPDATE_SCENE_MATCHING_LESSON: {
			url: `${API_URL}/lessons/scene-matching`,
			method: 'PUT',
		},
	},
	APP_CONFIGURATION: {
		GET_APP_CONFIG: {
			url: `${API_URL}/app-config`,
			method: 'GET',
		},
		UPDATE_LESSON_TYPE_CONFIG: {
			url: `${API_URL}/app-config/lessons-types`,
			method: 'PUT',
		},
		UPDATE_APP_PRONOUN_CONFIG: {
			url: `${API_URL}/app-config/pronouns`,
			method: 'PUT',
		},
		UPDATE_REGION_CONFIG: {
			url: `${API_URL}/app-config/regions`,
			method: 'PUT',
		},
		UPDATE_PLATFORM_VERSIONS_CONFIG: {
			url: `${API_URL}/app-config/app-platforms-versions`,
			method: 'PUT',
		},
		UPDATE_NUMBER_COMBINATION_CONFIG: {
			url: `${API_URL}/app-config/number-combination`,
			method: 'PUT',
		},
		UPDATE_TIME_COMBINATION_CONFIG: {
			url: `${API_URL}/app-config/time-combination`,
			method: 'PUT',
		},
	},
	CULTURE_CARD: {
		GET_GUIDES: {
			url: `${API_URL}/guides`,
			method: 'GET',
		},
		SEARCH_GUIDES: {
			url: `${API_URL}/guides/search`,
			method: 'GET',
		},
		CREATE_GUIDE: {
			url: `${API_URL}/guides`,
			method: 'POST',
		},
		UPDATE_GUIDE: {
			url: `${API_URL}/guides`,
			method: 'PUT',
		},
		DELETE_GUIDE: {
			url: `${API_URL}/guides`,
			method: 'DELETE',
		},

		GET_CATEGORIES: {
			url: `${API_URL}/card-categories`,
			method: 'GET',
		},
		SEARCH_CATEGORIES: {
			url: `${API_URL}/card-categories/search`,
			method: 'GET',
		},
		CREATE_CATEGORY: {
			url: `${API_URL}/card-categories`,
			method: 'POST',
		},
		UPDATE_CATEGORY: {
			url: `${API_URL}/card-categories`,
			method: 'PUT',
		},
		DELETE_CATEGORY: {
			url: `${API_URL}/card-categories`,
			method: 'DELETE',
		},

		GET_CARDS: {
			url: `${API_URL}/culture-cards`, // ?page&lessonsRegion&lessonNameSearchKey&cardTitleSearchKey&categoryTitleSearchKey
			method: 'GET',
		},
		SEARCH_CARDS: {
			url: `${API_URL}/culture-cards/search`, // ?searchKey
			method: 'GET',
		},
		DELETE_CARD: {
			url: `${API_URL}/culture-cards`,
			method: 'DELETE',
		},
		CREATE_CARD: {
			url: `${API_URL}/culture-cards`,
			method: 'POST',
		},
		GET_CARD: {
			url: `${API_URL}/culture-cards`, // /:id
			method: 'GET',
		},
		UPDATE_CARD: {
			url: `${API_URL}/culture-cards`,
			method: 'PUT',
		},
	},
	LIVE_SESSION_CARD: {
		GET_CARDS: {
			url: `${API_URL}/live-sessions-cards`, // ?page&lessonsRegion&lessonNameSearchKey&cardTitleSearchKey
			method: 'GET',
		},
		SEARCH_CARDS: {
			url: `${API_URL}/live-sessions-cards/search`, // ?searchKey
			method: 'GET',
		},
		DELETE_CARD: {
			url: `${API_URL}/live-sessions-cards`,
			method: 'DELETE',
		},
		CREATE_CARD: {
			url: `${API_URL}/live-sessions-cards`,
			method: 'POST',
		},
		GET_CARD: {
			url: `${API_URL}/live-sessions-cards`, // /:id
			method: 'GET',
		},
		UPDATE_CARD: {
			url: `${API_URL}/live-sessions-cards`,
			method: 'PUT',
		},
	},
	TAG: {
		SEARCH_TAGS: {
			url: `${API_URL}/tags/search`, // ?searchKey
			method: 'GET',
		},
		DELETE_TAG: {
			url: `${API_URL}/tags`,
			method: 'DELETE',
		},
		CREATE_TAG: {
			url: `${API_URL}/tags`,
			method: 'POST',
		},
		GET_TAG: {
			url: `${API_URL}/tags`, // /:id
			method: 'GET',
		},
		UPDATE_TAG: {
			url: `${API_URL}/tags`,
			method: 'PUT',
		},
	},
	SENTENCES: {
		GET_SENTENCES: {
			url: `${API_URL}/sentences`, // ?page&region&titleSearchKey&guideSearchKey
			method: 'GET',
		},
		SEARCH_SENTENCE: {
			url: `${API_URL}/sentences/search`, // ?searchKey
			method: 'GET',
		},
		DELETE_SENTENCE: {
			url: `${API_URL}/sentences`,
			method: 'DELETE',
		},
		CREATE_SENTENCE: {
			url: `${API_URL}/sentences`,
			method: 'POST',
		},
		GET_SENTENCE: {
			url: `${API_URL}/sentences`, // /:id
			method: 'GET',
		},
		UPDATE_SENTENCE: {
			url: `${API_URL}/sentences`,
			method: 'PUT',
		},
		SEARCH_BY_PREVIOUS_LESSONS: {
			url: `${API_URL}/sentences/search/sentences-based-on-previous-lessons`,
			method: 'GET',
		},
		SEARCH_SENTENCES: {
			url: `${API_URL}/sentences/search`,
			method: 'GET',
		},
	},
	SHOP: {
		GET_MODULES: {
			url: `${API_URL}/shop-modules`, // ?page&region&titleSearchKey&guideSearchKey
			method: 'GET',
		},
		SEARCH_MODULES: {
			url: `${API_URL}/shop-modules/search`, // ?searchKey
			method: 'GET',
		},
		DELETE_MODULE: {
			url: `${API_URL}/shop-modules`,
			method: 'DELETE',
		},
		CREATE_MODULE: {
			url: `${API_URL}/shop-modules`,
			method: 'POST',
		},
		GET_MODULE: {
			url: `${API_URL}/shop-modules`, // /:id
			method: 'GET',
		},
		UPDATE_MODULE: {
			url: `${API_URL}/shop-modules`,
			method: 'PUT',
		},
		GET_NEW_SHOP_MODULE_ORDER: {
			url: `${API_URL}/shop-modules/new-order`,
			method: 'GET',
		},
	},

	END_USERS_NOTIFICATIONS: {
		GET_NOTIFICATION: {
			url: `${API_URL}/end-users-notifications`, // /:id
			method: 'GET',
		},
		GET_NOTIFICATIONS: {
			url: `${API_URL}/end-users-notifications`, // ?page=number
			method: 'GET',
		},
		DELETE_NOTIFICATION: {
			url: `${API_URL}/end-users-notifications`, // /:id
			method: 'DELETE',
		},
		ADD_NOTIFICATION: {
			url: `${API_URL}/end-users-notifications`,
			method: 'POST',
		},
		UPDATE_NOTIFICATION: {
			url: `${API_URL}/end-users-notifications`,
			method: 'PUT',
		},
		SEARCH_USERS_QUESTIONS_ANSWERS: {
			url: `${API_URL}/onboarding-questions/end-users-questions-answers/search`, // ?searchKey=
			method: 'GET',
		},
	},

	END_USERS_MAILS: {
		GET_MAIL: {
			url: `${API_URL}/end-users-mails`, // /:id
			method: 'GET',
		},
		GET_MAILS: {
			url: `${API_URL}/end-users-mails`, // ?page=number
			method: 'GET',
		},
		DELETE_MAIL: {
			url: `${API_URL}/end-users-mails`, // /:id
			method: 'DELETE',
		},
		ADD_MAIL: {
			url: `${API_URL}/end-users-mails`,
			method: 'POST',
		},
		UPDATE_MAIL: {
			url: `${API_URL}/end-users-mails`,
			method: 'PUT',
		},
		GET_MAIL_TEMPLATES: {
			url: `${API_URL}/mails/templates`, // OR /:id
			method: 'GET',
		},
		GET_MAILS_TEMPLATE_VERSION: {
			url: `${API_URL}/mails/templates/:templateId/versions/:versionId'`,
			method: 'GET',
		},
	},

	FILES: {
		UPLOAD_IMAGE: {
			url: `${API_URL}/uploads/image`,
		},
		UPLOAD_AUDIO: {
			url: `${API_URL}/uploads/audio`,
		},
		UPLOAD_VIDEO: {
			url: `${API_URL}/uploads/video`,
		},
		DELETE_FILE: {
			url: `${API_URL}/uploads`,
		},
	},

	SCENE_MATCHING: {
		GET_SCENE_TAGS: {
			url: `${API_URL}/scene-tags`,
			method: 'GET',
		},
		SEARCH_SCENE_TAGS: {
			url: `${API_URL}/scene-tags/search`,
			method: 'GET',
		},
		CREATE_SCENE_TAG: {
			url: `${API_URL}/scene-tags`,
			method: 'POST',
		},
		UPDATE_SCENE_TAG: {
			url: `${API_URL}/scene-tags`,
			method: 'PUT',
		},
		DELETE_SCENE_TAG: {
			url: `${API_URL}/scene-tags`,
			method: 'DELETE',
		},

		GET_SCENE_CARDS: {
			url: `${API_URL}/scene-cards`,
			method: 'GET',
		},
		SEARCH_SCENE_CARDS: {
			url: `${API_URL}/scene-cards/search`,
			method: 'GET',
		},
		CREATE_SCENE_CARD: {
			url: `${API_URL}/scene-cards`,
			method: 'POST',
		},
		UPDATE_SCENE_CARD: {
			url: `${API_URL}/scene-cards`,
			method: 'PUT',
		},
		DELETE_SCENE_CARD: {
			url: `${API_URL}/scene-cards`,
			method: 'DELETE',
		},

		GET_SCENES_GROUPS: {
			url: `${API_URL}/scenes-groups`,
			method: 'GET',
		},
		SEARCH_SCENES_GROUPS: {
			url: `${API_URL}/scenes-groups/search`,
			method: 'GET',
		},
		CREATE_SCENES_GROUP: {
			url: `${API_URL}/scenes-groups`,
			method: 'POST',
		},
		UPDATE_SCENES_GROUP: {
			url: `${API_URL}/scenes-groups`,
			method: 'PUT',
		},
		DELETE_SCENES_GROUP: {
			url: `${API_URL}/scenes-groups`,
			method: 'DELETE',
		},
	},
};
